// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "yp_user_static/js/" + chunkId + "." + {"67":"648a68c7","114":"0f54a1d7","385":"03bf5715","490":"a10178a4","594":"5da5ca1a","625":"4a5293bb","795":"96112a77"}[chunkId] + ".js";
};